export type IPaginationDto<T> = Readonly<{
    "hydra:member": readonly T[];
    "hydra:totalItems": number;
}>;

export interface IPaginationModel<T> {
    pagesCount: number;
    items: T[];
}

export enum SortType {
    desc = "desc",
    asc = "asc",
}
